import toast, { ToastPosition } from 'react-hot-toast';
import { v4 as uuid } from 'uuid';

interface ISuccessToastProps {
  duration?: number;
  position?: ToastPosition;
  toastMessage: string;
}

export function SuccessToast({
  duration = 3000,
  position = 'top-right',
  toastMessage,
}: ISuccessToastProps) {
  return toast.success(toastMessage, {
    id: uuid(),
    iconTheme: {
      primary: '#FFF',
      secondary: '#24ba56',
    },
    duration,
    position,
    style: {
      background: '#24ba56',
      padding: '.75rem 1.25rem',
      color: '#FFF',
    },
  });
}
